import type { ReactNode } from 'react'

export function EmptyState({
  title,
  description,
  action,
}: {
  title: string
  description?: string
  action?: ReactNode
}) {
  return (
    <div className="flex min-h-[28vh] flex-col items-center justify-center rounded-ref-xl border border-dashed border-border/90 bg-card/60 px-6 py-16 text-center shadow-ref-soft ring-1 ring-border/60 backdrop-blur-[2px]">
      <h2 className="text-lg font-semibold tracking-tight text-foreground">{title}</h2>
      {description ? <p className="mt-2 max-w-md text-sm leading-relaxed text-muted-foreground">{description}</p> : null}
      {action ? <div className="mt-8">{action}</div> : null}
    </div>
  )
}
